"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchDebounce = void 0;
const react_1 = require("react");
function useSearchDebounce(delay = 750) {
    const [value, setValue] = (0, react_1.useState)("");
    const [searchQuery, setSearchQuery] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        const delayFn = setTimeout(() => setValue(searchQuery), delay);
        return () => clearTimeout(delayFn);
    }, [searchQuery, delay]);
    return [value, setSearchQuery];
}
exports.useSearchDebounce = useSearchDebounce;
